import React, { useState } from "react";
import { t } from "i18next";
import FloatingLabelInput from "../../../common/components/FloatingLabelInput";
import { updateContacts } from "../../../api/postCompanyData";
import Modal from "../../../common/components/MessageModal";

function ContactField({ icon, children }) {
    return (
        <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-gray-100 flex items-center justify-center flex-shrink-0 text-gray-500">
                {icon}
            </div>
            <div className="flex-1">{children}</div>
        </div>
    );
}

export default function ContactsInfo({ companyInfo }) {
    const [contacts, setContacts] = useState({
        website: companyInfo?.contacts?.website || "",
        telegram: companyInfo?.contacts?.telegram || "",
        whatsapp: companyInfo?.contacts?.whatsapp || "",
    });
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState({ show: false, message: "" });

    const handleChange = (field, value) => {
        setContacts(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await updateContacts(contacts);
            setModal({ show: true, message: t('dataUpdateSuccess') });
        } catch (error) {
            console.error("Update failed:", error);
            setModal({ show: true, message: t('updateError') });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div>
                <h3 className="text-base font-semibold text-gray-800 mb-5">{t('contacts')}</h3>
                <form className="flex flex-col gap-5 max-w-md" onSubmit={handleSubmit}>
                    <ContactField
                        icon={
                            <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4" stroke="currentColor" strokeWidth="1.8">
                                <circle cx="12" cy="12" r="9" />
                                <path d="M12 8v4l3 3" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M3.5 9h17M3.5 15h17" strokeLinecap="round" />
                            </svg>
                        }
                    >
                        <FloatingLabelInput
                            label={t('website')}
                            value={contacts.website}
                            onChange={(e) => handleChange('website', e.target.value)}
                            type="url"
                        />
                    </ContactField>

                    <ContactField
                        icon={
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-[#229ED9]">
                                <path d="M12 0C5.373 0 0 5.373 0 12c0 2.091.538 4.06 1.48 5.775L.057 23.252a.75.75 0 0 0 .916.916l5.477-1.423A11.94 11.94 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.447 1.394c-.16.16-.295.295-.605.295l.213-3.053 5.56-5.023c.242-.213-.054-.333-.373-.12l-6.871 4.326-2.962-.924c-.643-.204-.657-.643.136-.953l11.57-4.461c.537-.194 1.006.131.833.941z" />
                            </svg>
                        }
                    >
                        <FloatingLabelInput
                            label="Telegram"
                            value={contacts.telegram}
                            onChange={(e) => handleChange('telegram', e.target.value)}
                            type="text"
                        />
                    </ContactField>

                    <ContactField
                        icon={
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4 text-[#25D366]">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" />
                            </svg>
                        }
                    >
                        <FloatingLabelInput
                            label="WhatsApp"
                            value={contacts.whatsapp}
                            onChange={(e) => handleChange('whatsapp', e.target.value)}
                            type="text"
                        />
                    </ContactField>

                    <div>
                        <button
                            type="submit"
                            className="bg-[#147F26] text-white py-2.5 px-6 rounded-xl font-medium hover:bg-[#0f5f1a] disabled:opacity-60 transition"
                            disabled={loading}
                        >
                            {loading ? t('saving') : t('save')}
                        </button>
                    </div>
                </form>
            </div>
            {modal.show && (
                <Modal
                    message={modal.message}
                    onClose={() => setModal({ show: false, message: "" })}
                />
            )}
        </>
    );
}
